import { render, staticRenderFns } from "./SchoolStaffAttendancePage.vue?vue&type=template&id=348e3b44&scoped=true&"
import script from "./SchoolStaffAttendancePage.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e3b44",
  null
  
)

export default component.exports